import React from 'react';

const Footer = () => (
  <footer className="footer">
    <p className="madeWithLove">
      Made with love ♥️ by
      <a href="https://github.com/benwmx">@benwmx</a>
    </p>
  </footer>
);

export default Footer;
